// make all images available for rails views
// github.com/rails/webpacker/blob/554221c9c48b03f49b37b60e81193755a19a1465/docs/assets.md#link-in-your-rails-views
require.context('../../assets/images', true);

// NOTE: Core bundle needs to be imported first
import '../core-bundle/init';

// some components use i18n in the defaultProps which are evaluated
// at require time (so when we require Layout). This still has to
// be required before anything else
import '../init/locale';

import '../stylesheets/application.scss';

import ReactDOM from 'react-dom';
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import { initScripts, initRouting, initLaunchDarkly } from '../init';

import Store from '@app/store';
import Layout from '@component/layout';

import LaunchDarkly from '@module/launchdarkly';
import Analytics from '@module/analytics';

import { EXPERIMENT_VALIDATE_LD_SP } from '@app/constant/experiments';

const rootNode = document.querySelector('.root-node');

const App = ({ route, language }) => {
  React.useEffect(initScripts, []);
  return <Layout route={route} language={language} />;
};

App.propTypes = {
  route: PropTypes.object,
  language: PropTypes.string,
};

// Subscribe to our Redux stores
Store.subscribe(() => {
  const { route, session } = Store.getState();
  ReactDOM.render(
    <Provider store={Store}>
      <App route={route} language={session.language} />
    </Provider>,
    rootNode
  );
});

// init/routing.js conditionally adds routes based on launch darkly feature flags
initLaunchDarkly();

// Send out the version, outside of UI logic.
Analytics.trackSnowplowEvent({
  category: 'validate_launchdarkly',
  action: 'show_version',
  label: LaunchDarkly.getVariant(EXPERIMENT_VALIDATE_LD_SP),
});

// the router expects the Store.subscribe to be called before initialising it
initRouting();
